// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2TQhF","colMin":"styles_colMin__24qVj","colCheckbox":"styles_colCheckbox__3yh1E"};